import React, { useState } from 'react';
import { Container, Row, Col, Alert, Button, Form, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { recipesAPI } from '../utils/api';
import OrderForm from '../components/OrderForm';

const RecipeCostCalculator = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [recipeName, setRecipeName] = useState('');
  const [recipeDescription, setRecipeDescription] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (formData) => {
    setError('');

    if (!recipeName.trim()) {
      setError('กรุณาระบุชื่อสูตร');
      return;
    }

    if (formData.selectedMaterials.length === 0) {
      setError('กรุณาเพิ่มวัตถุดิบอย่างน้อย 1 รายการ');
      return;
    }

    setLoading(true);

    try {
      const recipeData = {
        name: recipeName.trim(),
        description: recipeDescription.trim() || undefined,
        note: formData.note,
        discountVat: formData.discountVat || 0,
        discountNonVat: formData.discountNonVat || 0,
        markupPercent: formData.markupPercent || 0,
        items: formData.selectedMaterials.map(item => ({
          materialId: item.materialId,
          quantity: item.quantity,
          unitCost: item.unitCost,
          note: item.note,
          hasVat: item.hasVat || false
        }))
      };

      await recipesAPI.create(recipeData);
      alert('บันทึกสูตรสำเร็จ');
      navigate('/recipes');
    } catch (err) {
      setError(err.response?.data?.message || 'เกิดข้อผิดพลาดในการบันทึกสูตร');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="main-content">
      <Row className="mb-4">
        <Col>
          <h2>
            <i className="bi bi-journal-plus me-2"></i>
            คำนวณต้นทุนสูตร
          </h2>
          <p className="text-muted">
            เลือกวัตถุดิบที่ต้องการ ระบุปริมาณ และดูต้นทุนรวมของสูตร
          </p>
        </Col>
      </Row>

      {error && (
        <Alert variant="danger" dismissible onClose={() => setError('')}>
          {error}
        </Alert>
      )}

      <Row className="mb-4">
        <Col md={12}>
          <Card>
            <Card.Body>
              <Card.Title>
                <i className="bi bi-card-text me-2"></i>
                ข้อมูลสูตร
              </Card.Title>
              <Form.Group className="mb-3">
                <Form.Label>ชื่อสูตร <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="ระบุชื่อสูตร เช่น ส้มตำไทย, ผัดกะเพรา"
                  value={recipeName}
                  onChange={(e) => setRecipeName(e.target.value)}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>รายละเอียดเพิ่มเติม</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  placeholder="หมายเหตุหรือรายละเอียดเพิ่มเติม (ไม่บังคับ)"
                  value={recipeDescription}
                  onChange={(e) => setRecipeDescription(e.target.value)}
                />
              </Form.Group>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <OrderForm
            initialSelectedMaterials={[]}
            onSubmit={handleSubmit}
            loading={loading}
            submitButtonText="บันทึกสูตร"
            submitButtonIcon="bi-floppy"
            allowPriceEdit={false}
            showMarkupInput={true}
          />

          <div className="d-grid gap-2 mb-4">
            <Button
              type="button"
              variant="outline-secondary"
              onClick={() => navigate('/recipes')}
            >
              <i className="bi bi-x-circle me-2"></i>
              ยกเลิก
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default RecipeCostCalculator;
